import React from 'react';
import { createPortal } from 'react-dom';

interface FilterBarTooltipProps {
  visible: boolean;
  left: number;
  top: number;
  items: string[];
  rightAligned?: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

/**
 * Tooltip rendered via React portal directly into document.body.
 * Position is injected via inline style (position: fixed) so it is never
 * clipped by any parent container with overflow: hidden.
 */
export const FilterBarTooltip: React.FC<FilterBarTooltipProps> = ({
  visible,
  left,
  top,
  items,
  rightAligned = false,
  onMouseEnter,
  onMouseLeave,
}) => {
  if (!visible || items.length === 0) return null;

  return createPortal(
    <div
      className={`filter-bar-tooltip${rightAligned ? ' filter-bar-tooltip--right-aligned' : ''}`}
      style={{
        '--tooltip-left': `${left}px`,
        '--tooltip-top': `${top}px`,
      } as React.CSSProperties}
      role="tooltip"
      aria-live="polite"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onMouseEnter}
      onBlur={onMouseLeave}
    >
      <ul className="filter-bar-tooltip__list">
        {items.map((item) => (
          <li key={item} className="filter-bar-tooltip__item">
            {item}
          </li>
        ))}
      </ul>
    </div>,
    document.body,
  );
};
